import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import TitledPanel from './TitledPanel';

class IRIgeneration extends React.Component {

    render() {

        const { classes, iriFormat, onChange, margin } = this.props;

        return (
            <TitledPanel title="IRI Format" margin={margin}>
                <FormControl component="fieldset" style={{ marginLeft: 12 }}>
                    <RadioGroup row aria-label="IRI format" name="iriFormat" value={iriFormat} onChange={onChange}>
                        <FormControlLabel data-test="select-uuid" value="UUID" control={<Radio color="primary" />} label="UUID"
                            classes={{ label: classes.formLabelInline }}
                        />
                        <FormControlLabel data-test="select-label" value="Label" control={<Radio color="primary" />} label="Label"
                            classes={{ label: classes.formLabelInline }}
                        />
                    </RadioGroup>
                </FormControl>
            </TitledPanel>
        );
    }
}

IRIgeneration.defaultProps = {
    margin: true
};

IRIgeneration.propTypes = {
    iriFormat: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    classes: PropTypes.object,
    margin: PropTypes.bool
};

export default withStyles(styles)(IRIgeneration);